import React from 'react'

export const Play = () => (
  <svg fill="#fff" height="60" viewBox="0 0 60 60" width="60">
    <path d="M8 5v14l11-7z" />
    <path d="M0 0h60v60H0z" fill="none" />
  </svg>
)

export const Box = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="12" width="12">
    <rect width="12" height="12" fill="none" strokeWidth="2" stroke="#fff" />
  </svg>
)
export const SolidBox = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="12" width="12">
    <rect width="12" height="12" fill="#fff" strokeWidth="2" stroke="#fff" />
  </svg>
)
export const Expand = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="#fff" height="24" viewBox="0 0 24 24" width="24">
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" />
  </svg>
)
export const Close = () => (
  <svg id="close_button" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#fff">
    <path d="M19 6.41l-1.41-1.41-5.59 5.59-5.59-5.59-1.41 1.41 5.59 5.59-5.59 5.59 1.41 1.41 5.59-5.59 5.59 5.59 1.41-1.41-5.59-5.59z" />
    <path d="M0 0h24v24h-24z" fill="none" />
  </svg>
)
export const Menu = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-menu"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
)


// WEBPACK FOOTER //
// ./src/components/icons/index.js